export const GrtJsxTem1 = function (props) {
    return (<div>
      我是jsx生成的组件11111

    </div>);
};
